import { render, staticRenderFns } from "./addFitoAndFertility.vue?vue&type=template&id=d3206e9a"
import script from "./addFitoAndFertility.vue?vue&type=script&lang=js"
export * from "./addFitoAndFertility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports